/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api: {
    currentVersion: 'v1',
    //endpoint: 'http://webmail.noviacom.it:5000/api',
    //endpoint: 'http://192.168.25.58:5000/api',
    endpoint: 'https://erg.smartbug.cloud:41000/api',
  },
  socket: { // socket settings
    globalTopics: ['alerts'],
    //endpoint: 'http://webmail.noviacom.it:15000'// socket endpoint
    //endpoint: 'http://192.168.25.58:15000',
    endpoint: 'https://erg.smartbug.cloud:16000',
  },
  toastr: { // Alert notification settings
    defaultTimeout: 3000, //default timeout before toastr disappears
    defaultStatus: 'info' // info is the defautl status (blue with a question mark icon '?') 
  }
};
